import { render } from "./KhataKharchSettings.vue?vue&type=template&id=47742a1d&scoped=true"
import script from "./KhataKharchSettings.vue?vue&type=script&lang=js"
export * from "./KhataKharchSettings.vue?vue&type=script&lang=js"

import "./KhataKharchSettings.vue?vue&type=style&index=0&id=47742a1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47742a1d"]])

export default __exports__